module.exports = __webpack_public_path__ + "static/media/default-card-icon.a922d7df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-card-icon.png
// module id = 1124
// module chunks = 2